export type ItemLinkProps = {
  label: string;
  redirectUrl: string;
  route?: { path?: string };
  openNewTab?: boolean;
  websiteUrl: string;
  locale: string;
};

export function ItemLink({ label, websiteUrl, route, openNewTab, redirectUrl, locale }: ItemLinkProps) {
  const localePrefix = locale === 'en' ? '' : `/${locale}`;

  if (!openNewTab && !redirectUrl && !route?.path) {
    return <span>{label}</span>;
  }

  if (openNewTab || redirectUrl) {
    return (
      <a href={redirectUrl} target="_blank" rel="noreferrer">
        {label}
      </a>
    );
  }

  return <a href={`${websiteUrl}${localePrefix}/${route?.path}`}>{label}</a>;
}
